<template>
    <div class="dashboard">
        <div class="dashboard-text" v-html="replacedHTML">
        </div>

        <ul class="services" v-if="services.length && role == 'consumer'">
            <li v-for="service in services" :key="service.id">
                <router-link :to="{ name: 'ProjectsCreate', query: { service: service.id } }">
                    <h2>{{ service.name }}</h2>
                    <p v-html="service.description"></p>
                </router-link>
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    name: "DashboardPage",
    components: {},
    data() {
        return {
            columns: [
                { text: `Data`, attribute: 'date' },
                { text: `Cliente`, attribute: 'client' },
                { text: `Projecto`, attribute: 'project' },
                { text: `Ficheiro`, attribute: 'file' },
                { text: 'Estado', attribute: 'state', icon: "", method: this.delete },
            ],
        }
    },

    computed: {
        replacedHTML() {
            if (!(this.currentUser && this.explanation)) {
                return ""
            }
            const data = {
                name: this.currentUser.displayName
            }
            return this.explanation.replace(/{{(.*?)}}/g, (_, key) => data[key.trim()] || '');
        },
        explanation() {
            return this.$store.state.instance.data.settingExplanation
        },
        instanceSetting() {
            return this.$store.state.instance.data.settingExplanation
        },
        companies() {
            return this.$store.state.companies.all
        },
        currentUser() {
            return this.$store.state.users.currentUser
        },
        role() {
            return this.$store.state.users.role
        },
        services() {
            return this.$store.state.services.all
        },
        users() {
            const users = this.$store.state.users.all
            if (users == null) return
            return users.sort((a, b) => {
                if (a.name == null || b.name == null) return
                return a.name.localeCompare(b.name)
            })
        },
    },

    mounted() {
    }
}
</script>

<style lang="scss" scoped>
@import '@/assets/utilities/_variables.scss';

.dashboard {
    padding: 2rem;

    .services {
        display: grid;
        gap: 1rem;
        list-style: none;
        padding: 0;
        margin: 0 0 1rem;

        @media screen and (min-width: $desktop-min-width) {
            grid-template-columns: 1fr 1fr 1fr;
        }

        li {
            padding: 1rem;
            background-color: var(--card-bg);
            border-radius: .5rem;
            cursor: pointer;

            .title {
                font-size: 1.25rem;
                font-weight: bold;
                margin: 0;
            }
        }
    }
}
</style>
